import { List } from '@/components/List/List';
import { useAppTranslation } from '@/hooks/useAppTranslation';
import { Ionicons } from '@expo/vector-icons';
import { SizableText, useTheme } from 'tamagui';

export type SpeciesSearchResultItem = {
  value: string;
  scientificName: string;
  label: string;
  subtitle?: string;
  isSelected: boolean;
};

interface SpeciesSearchResultsProps {
  items: SpeciesSearchResultItem[];
  onSelect: (item: SpeciesSearchResultItem) => void;
}

export const SpeciesSearchResults = ({
  items,
  onSelect,
}: SpeciesSearchResultsProps): React.ReactElement | null => {
  const theme = useTheme();
  const { t } = useAppTranslation();

  if (items.length === 0) {
    return (
      <SizableText color="$secondary75">
        {t('speciesSearch.empty.noResults')}
      </SizableText>
    );
  }

  const sections = [
    {
      id: 'species-search-results',
      title: '',
      items: items.map((item) => ({
        id: item.value,
        title: item.label,
        subtitle: item.subtitle ?? '',
        iconAfter: (
          <Ionicons
            name={item.isSelected ? 'checkmark' : 'chevron-forward'}
            size={18}
            color={theme.color?.val}
          />
        ),
        onPress: (): void => onSelect(item),
      })),
    },
  ];

  return <List sections={sections} gap="$2" />;
};
